import * as yup from 'yup';

export const sendPasswordResetSchema = yup.object({
  email: yup.string().required().email('Email Address is invalid'),
});
